/* tslint:disable */
var TBuildLine = (function ()
{
    var buildView = function (selection, mode, context)
    {
        return BetSlipTemplateConroller.getLineTypeTemplate(BetSlip.TemplateType).buildView(selection, mode, context);
    };

    var buildInnerView = function(selection, mode, context)
    {
        return BetSlipTemplateConroller.getLineTypeTemplate(BetSlip.TemplateType).buildInnerView(selection, mode, context);
    };

    var defaultLine = function (selection, selectionType, mode, context)
    {
        return BetSlipTemplateConroller.getLineTypeTemplate(BetSlip.TemplateType).defaultLine(selection, selectionType, mode, context);
    };

    var UKLine = function (selection, selectionType, mode, context)
    {
        return BetSlipTemplateConroller.getLineTypeTemplate(BetSlip.TemplateType).UKLine(selection, selectionType, mode, context);
    };

    var editModeLine = function (selection, selectionType, mode, context)
    {
        return BetSlipTemplateConroller.getLineTypeTemplate(BetSlip.TemplateType).editModeLine(selection, selectionType, mode, context);
    };
     
    var yourBetModeLine = function (selection, selectionType, mode, context)
    {
        return "";
    }

    return {
        buildView: buildView,
        buildInnerView: buildInnerView,
        defaultLine: defaultLine,
        UKLine: UKLine,
        editModeLine:editModeLine,
        yourBetModeLine:yourBetModeLine
     };
}());

window.TBuildLine = TBuildLine;